import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';

export const isSuggestedFaqActionable = (status?: SuggestedFaqStatus): boolean => status === SuggestedFaqStatus.PENDING;
